module.exports = __webpack_public_path__ + "img/sp1.cfebbb7b.svg";